import { render, staticRenderFns } from "./universComponent.vue?vue&type=template&id=4d5cfcab&"
import script from "./universComponent.vue?vue&type=script&lang=js&"
export * from "./universComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports